'use client';
function isMantineColorScheme(value) {
  return value === "auto" || value === "dark" || value === "light";
}

export { isMantineColorScheme };
//# sourceMappingURL=is-mantine-color-scheme.mjs.map
